export default {
  comparePlans: 'Comparar Planos',
  plan1: 'Plano 1',
  plan2: 'Plano 2',
  selectPlanToCompare: 'Por favor selecione um Plano para comparar',
  betaOptimizerTooltip: 'Este plano usa o novo otimizador (beta)',
  fullPeriodSummary: 'Resumo do Período Completo',
  monthlyDetailView: 'Visão Detalhada Mensal',
  weeklyDetailView: 'Visão Detalhada Semanal',
  touchpoints: 'Pontos de Contato',
  segments: 'Segmentos'
}
